import { Box } from "@mui/material";
import styled from "styled-components";
import { color } from "~/assets/styles/colors";
import Image from '~/assets/img/iconDash/hand6.png';


export const Content = styled(Box)`
	color: ${color.softBlack};
	padding: 30px;
	margin-left: 22px;
	font-size: 16px;
	display: flex;
	flex-direction: row;
	align-items: center;
	.content-name{
		margin-left: 6px;
	}

	.content-img {
		margin-left: 10px;
		width: 25px;
		height: 25px;
		background-image: url(${Image});
		background-size: cover;
		background-repeat: no-repeat;
	}

	@media screen and (max-width: 1200px) {
		font-size: 16px;
		padding: 10px;
		.content-img {
			margin-left: 0px;
			width: 25px;
			height: 25px;
		}
	}

	@media screen and (max-width: 1077px) {
		font-size: 14px;
		padding: 0px;
		.content-img {
			width: 25px;
			height: 25px;
		}
	}

	@media screen and (max-width: 875px) {
		.content-img {
			display: none;
		}
	}
`;
